export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

import { Stack, useLocalSearchParams } from 'expo-router';
import Head from 'expo-router/head';
import { Suspense } from 'react';

import { fetchStaticPageBySlug, useSuspenseQuery } from '@fhs/client';
import { Flex } from '@fhs/ui';
import LoadingAnimation from '@fhs-legacy/frontend/src/components/loading-animation';
import LoadingContainer from '@fhs-legacy/frontend/src/components/loading-animation/loading-container';
import NotFound from '@fhs-legacy/frontend/src/pages/not-found';
import { RenderCurrentStaticPage } from '@fhs-legacy/frontend/src/pages/static/render-current-static-page';
import { useNetworkContext } from '@fhs-legacy/frontend/src/state/network';

const useStaticPageQuery = (staticPageSlug: string) => {
  const { groq } = useNetworkContext().sanityEndpoints;

  return useSuspenseQuery({
    queryKey: ['staticPage', staticPageSlug],
    queryFn: ({ signal }) => fetchStaticPageBySlug(groq, staticPageSlug, signal),
  });
};

function StaticPage() {
  const { staticPage } = useLocalSearchParams<{ staticPage: string }>();

  const { data: staticPageData } = useStaticPageQuery(staticPage);

  if (!Object.keys(staticPageData).length) {
    return <NotFound />;
  }

  return (
    <>
      <Head>
        <title>
          {staticPageData.title ? `${staticPageData.title} - Firehouse Subs` : 'Firehouse Subs'}
        </title>
      </Head>
      <Stack.Screen options={{ title: staticPageData.title }} />
      <Flex testID="static-page" key={staticPage}>
        <Flex>
          <RenderCurrentStaticPage currentPage={staticPageData} />
        </Flex>
      </Flex>
    </>
  );
}

export default () => {
  return (
    <Suspense
      fallback={
        <LoadingContainer>
          <LoadingAnimation />
        </LoadingContainer>
      }
    >
      <StaticPage />
    </Suspense>
  );
};
